export default __webpack_public_path__ + "static/media/chimneytrackicon.cf85f73f.png";